import { formatDate } from "../../../services/util";
import moment from "moment";

export const getMonthEnd = () => formatDate(moment().endOf("month"));

export const getMonthStart = () => formatDate(moment().startOf("month"));
